import { z } from 'zod';

import { Address, Geolocation } from './Address';

export const regionSchema = z.object({
  city: z.string().optional(),
  country: z.string().optional(),
  state: z.string().optional(),
  state_code: z.string().optional(),
  zip: z.string().optional(),
});

export type Region = z.infer<typeof regionSchema>;

type PartialVisitor = { address?: Address; geolocation?: Partial<Geolocation>; zip?: string };

export const getVisitorsRegion = (visitor?: PartialVisitor): Region | undefined => {
  if (!visitor) {
    return undefined;
  }

  const { address, geolocation, zip } = visitor;

  if (address) {
    return address;
  }

  const city = geolocation?.source !== 'ip' ? geolocation?.city : undefined;
  const { country, state, state_code } = geolocation ?? {};

  return { city, country, state, state_code, zip: zip || geolocation?.zip };
};
